import { Component, OnInit, HostListener, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  @Output() removeActiveInHeader = new EventEmitter();
  selectedMenu = false;
  year: string;

  ngOnInit() {
    this.year = (new Date()).getFullYear().toString();
  }
  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {

    // window의 scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    // console.log('[scroll]', scrollPosition);

    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }

    // var app = angular.module('myApp', []);
    // app.controller('datCtrl', function($scope) {
    //     $scope.today = new Date();
    // });

  }

  // TODO: Cross browsing
  gotoTop() {
    this.removeActiveInHeader.emit(null);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    // this.selectedMenu=!this.selectedMenu;
  }
}
